
<style scoped>
.header {
  font-size: 14px;
  text-align: center;
  border-bottom: 1px solid #eee;
  font-weight: bold;
  padding-bottom: 20px;
  color: #832c75;
}
.list .item {
  display: flex;
  border-bottom: 1px solid #f8f8f8;
  line-height: 36px;
}
.list .item .left,
.list .item .right {
  flex: 1;
  display: flex;
}
.list .item .left .title,
.list .item .right .title {
  width: 220px !important;
  font-weight: bold;
}
.list .item .left .content,
.list .item .right .content {
  color: #666;
  flex: 1;
}
.box {
  max-height: 600px;
  overflow-y: scroll;
}
</style>
<style scoped>
.header {
  font-size: 14px;
  text-align: center;
  border-bottom: 1px solid #eee;
  font-weight: bold;
  padding-bottom: 20px;
  color: #832c75;
}
.list .item {
  display: flex;
  border-bottom: 1px solid #f8f8f8;
  line-height: 36px;
}
.list .item .left,
.list .item .right {
  flex: 1;
  display: flex;
}
.list .item .left .title,
.list .item .right .title {
  width: 120px;
  font-weight: bold;
}
.list .item .left .content,
.list .item .right .content {
  color: #666;
  flex: 1;
}
</style>
<template>
  <a-modal
    :title="title"
    :visible="visible"
    @cancel="cancel"
    :width="1000"
    :footer="null"
    :bodyStyle="{ maxHeight: '85vh', overflow: 'auto' }"
  >
    <div class="box">
      <div class="header">
        <span>基本信息</span>
      </div>
      <div class="base" v-if="data != null">
        <!-- 基本信息 -->
        <baseInfo :data="data" />
      </div>
      <div>
        <div>
          <div class="header" style="margin-top: 20px">
            <span>认知、语言、动作</span>
          </div>
          <div class="list">
            <div class="item">
              <div class="left">
                <div class="title">认知(CG):</div>
                <div class="content">{{ data.score_cg }}</div>
              </div>
              <div class="right">
                <div class="title">语言-接受性沟通(RC):</div>
                <div class="content">{{ data.score_rc }}</div>
              </div>
            </div>
            <div class="item">
              <div class="left">
                <div class="title">语言-表达性沟通(EC):</div>
                <div class="content">{{ data.score_ec }}</div>
              </div>
              <div class="right">
                <div class="title">动作-精细动作(FM):</div>
                <div class="content">{{ data.score_fm }}</div>
              </div>
            </div>
            <div class="item">
              <div class="left">
                <div class="title">动作-粗大动作(GM):</div>
                <div class="content">{{ data.score_gm }}</div>
              </div>
            </div>
          </div>
          
          <!-- 添加详细题目得分展示（选项卡方式） -->
          <div v-if="parsedAnswerData" style="margin-top: 20px">
            <div class="header">
              <span>详细题目得分</span>
            </div>
            
            <a-tabs default-active-key="cg" @change="handleTabChange">
              <!-- 认知(CG)题目得分 -->
              <a-tab-pane key="cg" tab="认知(CG)" v-if="parsedAnswerData.cg && parsedAnswerData.cg.length > 0">
                <div class="items-container">
                  <div class="item-row" v-for="(item, index) in parsedAnswerData.cg" :key="'cg-'+index">
                    <span class="item-label">题目 {{ item.itemNo }}：{{ getItemTitle('cg', index) }}</span>
                    <span class="item-score">{{ item.score !== null ? item.score : '未作答' }}</span>
                  </div>
                </div>
              </a-tab-pane>
              
              <!-- 语言-接受性沟通(RC)题目得分 -->
              <a-tab-pane key="rc" tab="语言-接受性沟通(RC)" v-if="parsedAnswerData.rc && parsedAnswerData.rc.length > 0">
                <div class="items-container">
                  <div class="item-row" v-for="(item, index) in parsedAnswerData.rc" :key="'rc-'+index">
                    <span class="item-label">题目 {{ item.itemNo }}：{{ getItemTitle('rc', index) }}</span>
                    <span class="item-score">{{ item.score !== null ? item.score : '未作答' }}</span>
                  </div>
                </div>
              </a-tab-pane>
              
              <!-- 语言-表达性沟通(EC)题目得分 -->
              <a-tab-pane key="ec" tab="语言-表达性沟通(EC)" v-if="parsedAnswerData.ec && parsedAnswerData.ec.length > 0">
                <div class="items-container">
                  <div class="item-row" v-for="(item, index) in parsedAnswerData.ec" :key="'ec-'+index">
                    <span class="item-label">题目 {{ item.itemNo }}：{{ getItemTitle('ec', index) }}</span>
                    <span class="item-score">{{ item.score !== null ? item.score : '未作答' }}</span>
                  </div>
                </div>
              </a-tab-pane>
              
              <!-- 动作-精细动作(FM)题目得分 -->
              <a-tab-pane key="fm" tab="动作-精细动作(FM)" v-if="parsedAnswerData.fm && parsedAnswerData.fm.length > 0">
                <div class="items-container">
                  <div class="item-row" v-for="(item, index) in parsedAnswerData.fm" :key="'fm-'+index">
                    <span class="item-label">题目 {{ item.itemNo }}：{{ getItemTitle('fm', index) }}</span>
                    <span class="item-score">{{ item.score !== null ? item.score : '未作答' }}</span>
                  </div>
                </div>
              </a-tab-pane>
              
              <!-- 动作-粗大动作(GM)题目得分 -->
              <a-tab-pane key="gm" tab="动作-粗大动作(GM)" v-if="parsedAnswerData.gm && parsedAnswerData.gm.length > 0">
                <div class="items-container">
                  <div class="item-row" v-for="(item, index) in parsedAnswerData.gm" :key="'gm-'+index">
                    <span class="item-label">题目 {{ item.itemNo }}：{{ getItemTitle('gm', index) }}</span>
                    <span class="item-score">{{ item.score !== null ? item.score : '未作答' }}</span>
                  </div>
                </div>
              </a-tab-pane>
            </a-tabs>
          </div>

        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { Detail } from "../../commonApi";
export default {
  components: {},
  props: {
    item: [Object],
    detailVisible: [Boolean],
  },
  watch: {
    item: {
      handler: function (e) {
        this.data = e;
        this.id = e.id;
      },
      immediate: true,
      deep: true,
    },
    detailVisible: {
      handler: function (e) {
        this.visible = e;
        if (this.visible) {
          this.getDetail();
        }
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler: function(val) {
        if (val && val.answer_data) {
          try {
            this.parsedAnswerData = JSON.parse(val.answer_data);
          } catch (error) {
            console.error('解析 answer_data 出错:', error);
            this.parsedAnswerData = null;
          }
        } else {
          this.parsedAnswerData = null;
        }
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      title: "",
      visible: true,
      id: "",
      data: null,
      type: "",
      parsedAnswerData: null,
      activeTabKey: "cg", // 添加选项卡当前激活的key
      
      // 添加题目标题数据（从添加页面复制过来）
      cgTitles: [
        '被抱起时平静下来', '注视物体', '对照护者的反应', '注意转移', '表现出视觉偏好',
        '对气球（图片）习惯', '探索物体', '拍打桌子', '预期注视', '看图',
        '寻找消失的物品', '搅动勺子', '杯中积木', '寻找隐藏的物品', '吊环',
        '取出食物粒', '粉色板', '专心听故事', '蓝色板系列：1块', '插板',
        '用铅笔获取物体', '表征性游戏', '蓝色板系列：9块', '空间记忆：3张卡', '假想性游戏',
        '回忆名字', '拼图：猫', '区分图形', '空间记忆：6张卡', '背数'
      ],
      rcTitles: [
        '讲话时平静', '对人声有反应', '对照护者的反应', '注意转移', '探索物体',
        '将物体拿到嘴边', '敲打物体', '对名字有应答', '听辨词语', '对日常社交要求有应答',
        '识别物品', '识别图片系列：3个正确', '娃娃部位系列：2个正确', '识别图片系列：6个正确', '识别衣物',
        '娃娃部位系列：5个正确', '理解局部/整体的关系', '理解大小', '理解复数形式', '理解"更多"',
        '理解重量', '理解"较少"'
      ],
      ecTitles: [
        '未分化发音', '社会性微笑', '发声表达情绪', '社会性发声或笑', '发出元音',
        '吸引关注/互动', '发出辅音', '使用肢体语言', '含糊不清的话', '引导他人对物体的关注',
        '发起游戏', '合理使用词语', '理解度：50%', '物品命名', '回答是否题',
        '理解度：75%', '说出3个词的句子', '动作命名系列：3个正确', '提出问题', '使用现在进行时',
        '使用不同的词语组合', '动作命名系列：5个正确', '说出物体用途'
      ],
      fmTitles: [
        '目光追随移动的人', '目光追随吊环：水平方向', '尝试伸手入口', '手握吊环', '头随吊环转动',
        '手掌握持反射', '伸手拿/碰积木', '积木抓握系列：整手抓握', '看着食物粒', '抓食物粒系列：整手抓握',
        '将积木或圆环换手', '自主进食', '积木抓握系列：拇指-指尖抓握', '抓食物粒系列：灵巧钳式抓握', '翻书',
        '手指戳插板', '主动涂画', '抓握铅笔系列：过渡阶段', '将硬币投入存钱罐', '抓握铅笔系列：静态三点握笔',
        '搭积木系列：6块积木', '拼插积木', '搭积木系列：8块积木', '穿积木', '折纸',
        '模仿画加号', '抓握铅笔系列：动态握笔'
      ],
      gmTitles: [
        '伸展双臂和双腿', '控制头部：保持头部直立3秒', '俯卧时控制头部：45°', '向下降落伞反射', '翻身：从俯卧到仰卧',
        'ATNR非对称性紧张性颈反射', '翻身：从仰卧到侧卧', '足抓握反射', '站立：背部竖直', '拉起至坐位',
        '爬行：腹部', '从坐位转为手膝位', '支撑体重', '爬行：爬行动作', '有支撑行走',
        '有支撑侧身走', '独站', '行走：没有帮助', '向前扔球', '独立蹲下',
        '向后倒着走', '协调地跑', '跳：双脚跳', '无需支撑，单脚平衡站立系列：2秒', '踮脚走路',
        '单脚跳1.5米', '无需支撑，单脚平衡站立：6秒'
      ]
    };
  },
  created() {},
  methods: {
    async getDetail() {
      const res = await Detail({ id: this.id });
      if (res && res.code == 0) {
        this.data = res.bayleyScreeningAssessment;
        // 解析 answer_data
        if (this.data.answer_data) {
          try {
            this.parsedAnswerData = JSON.parse(this.data.answer_data);
          } catch (error) {
            console.error('解析 answer_data 出错:', error);
            this.parsedAnswerData = null;
          }
        }
      }
    },
    handleTabChange(key) {
      this.activeTabKey = key;
    },
    // 新增方法：根据类型和索引获取题目标题
    getItemTitle(type, index) {
      const titleMaps = {
        'cg': this.cgTitles,
        'rc': this.rcTitles,
        'ec': this.ecTitles,
        'fm': this.fmTitles,
        'gm': this.gmTitles
      };
      
      const titles = titleMaps[type];
      return titles && titles[index] ? titles[index] : '';
    },
    cancel() {
      this.visible = false;
      this.$emit("detailCancel");
    },
  },
};
</script>

<style>
/* 添加详细题目得分的样式 */
.items-container {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 20px;
}

.item-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.item-row:last-child {
  border-bottom: none;
}

.item-label {
  font-weight: 500;
  color: #333;
}

.item-score {
  color: #832C75;
  font-weight: bold;
}

/* 选项卡样式 */
.ant-tabs-nav .ant-tabs-tab-active {
  color: #832C75 !important;
  font-weight: bold;
}

.ant-tabs-ink-bar {
  background-color: #832C75 !important;
}

.ant-tabs-nav .ant-tabs-tab:hover {
  color: #832C75 !important;
}

/* 详细题目得分的样式 */
.items-container {
  max-height: 400px; /* 增加高度，因为现在是选项卡形式 */
  overflow-y: auto;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 20px;
}
</style>
